import React from "react";
import Blocker from "../../../../Misc/Blocker";
import Context from "../../../../../Context";
import CrumbsProvider from "../../../../Misc/CrumbsProvider";
import Group from "./Group";

export default class Groups extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      activeItem: false,
      items: {},
    };
  }

  componentDidMount() {
    this.load();
  }

  load = async () => {
    this.setState({ pending: true });
    let result = false;

    let items = {};
    result = await this.context.api.q("/admin/group/list");
    if (result !== false) {
      if (result["id"]) result = [result];
      if (Array.isArray(result)) {
        result.forEach((item) => {
          items[item.id] = item;
        });
      }
    }

    this.setState({ pending: false, items });
  };

  //Handles tree navigation click
  navigate = (id) => {
    this.setState({ activeItem: id });
  };

  afterItemChange = async (id = false) => {
    await this.load();
    this.setState({ activeItem: id });
  };

  //Render layout
  render() {
    return (
      <>
        <CrumbsProvider title="Группы" />
        <Blocker on={this.state.pending}>
          <div className="card card-custom gutter-b card-stretch ">
            <div className="card-body  ">{this.renderContent()}</div>
          </div>
        </Blocker>
      </>
    );
  }

  //Render list
  renderList() {
    return (
      <>
        {Object.entries(this.state.items).map(([id, item]) => (
          <div
            key={id}
            onClick={() => this.navigate(id)}
            className={`font-weight-bold py-1 mb-2 ${
              this.state.activeItem === id ? "bg-light" : ""
            } text-dark text-hover-muted cursor-pointer`}
          >
            {item.name}
          </div>
        ))}
      </>
    );
  }

  //Render contents
  renderContent() {
    if (Object.keys(this.state.items).length === 0) {
      return (
        <div className="d-flex justify-content-center align-items-center  ">
          <div className="spinner"></div>
        </div>
      );
    }
    return (
      <div className="row h-100 ">
        <div className="col-lg-4 border-right mb-10 mb-lg-0">
          {this.renderList()}
        </div>
        <div className="col-lg-8">
          <Group
            item={this.state.items[this.state.activeItem]}
            key={this.state.activeItem}
            onFinish={this.afterItemChange}
          />
        </div>
      </div>
    );
  }
}
